'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.defaultProps = exports.propTypes = undefined;

var _react = require('react');

var propTypes = exports.propTypes = {
    id: _react.PropTypes.string.isRequired,
    type: _react.PropTypes.string,
    name: _react.PropTypes.string,
    isSelected: _react.PropTypes.bool,

    // ATTRIBUTES
    value: _react.PropTypes.string,
    label: _react.PropTypes.string,
    placeholder: _react.PropTypes.string,

    // PROPERTIES
    color: _react.PropTypes.string,
    backgroundColor: _react.PropTypes.string,
    fontSize: _react.PropTypes.string,
    fontFamily: _react.PropTypes.string,
    fontStyle: _react.PropTypes.string,
    fontWeight: _react.PropTypes.string,
    textDecoration: _react.PropTypes.string,
    padding: _react.PropTypes.string,
    margin: _react.PropTypes.string,
    borderStyle: _react.PropTypes.string,
    borderWidth: _react.PropTypes.string,
    borderColor: _react.PropTypes.string,

    className: _react.PropTypes.string,
    selectComponent: _react.PropTypes.func,
    changeProperty: _react.PropTypes.func
};

var defaultProps = exports.defaultProps = {
    color: '#00000',
    backgroundColor: '#FFFFFF',
    fontSize: '14px',
    fontFamily: '',
    fontStyle: 'normal',
    fontWeight: 'normal',
    textDecoration: 'none',
    padding: '0px',
    margin: '0px',
    borderStyle: 'solid',
    borderWidth: '0px',
    borderColor: '#000000'
};


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/InputText/props.js
// module id = 343
// module chunks = 0